import { render } from "./DeletedProfilePage.vue?vue&type=template&id=510e4bf4&scoped=true"
import script from "./DeletedProfilePage.vue?vue&type=script&lang=js"
export * from "./DeletedProfilePage.vue?vue&type=script&lang=js"

import "./DeletedProfilePage.vue?vue&type=style&index=0&id=510e4bf4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510e4bf4"]])

export default __exports__